import {produce} from "immer";

const intitalState = {
  tutoriel: false,
  season: null,
  meteo: null,
  beach_details: null,
  beaches_list: null,
  beaches_favorites: [],
  beaches_filters: {
    favorites: false,
    service_1: false,
    service_2: false,
    service_3: false,
    service_4: false,
    service_5: false,
    service_6: false,
    service_7: false,
    service_8: false,
  },
  risks : { ostreopsis: 0, meduses: 0, physalies: 0, dangers : 0},
  notifications: false,
  all_beaches_closed: true,
};

export const beachesReducers = (state = intitalState, action) => {
  switch (action.type) {
      case 'GET_SEASON_LOADING':
        return {
          ...state,
        };

    case 'GET_BEACH_DETAILS_SUCCESS':
      return {
        ...state,
        beach_details: action.beach_details,
        meteo: action.meteo,
      };

    case 'SET_BEACH_DETAILS':

    let new_beach_details = action.beach_details;

    if(state.beach_details) {
      if(state.beach_details.id === action.beach_details.id) {
        if(Object.keys(action.beach_details).length  < Object.keys(state.beach_details).length) {
          new_beach_details = state.beach_details;
        }
      }
    }

      return {
        ...state,
        beach_details: new_beach_details,
      };

    case 'CLEAR_BEACH_DETAILS':
      return {
        ...state,
        beach_details: null,
        risks : { ostreopsis: 0, meduses: 0, physalies: 0, dangers : 0},
        beaches_filters: {
          favorites: false,
          service_1: false,
          service_2: false,
          service_3: false,
          service_4: false,
          service_5: false,
          service_6: false,
          service_7: false,
          service_8: false,
        },
      };

    case 'GET_SEASON_SUCCESS':
      return {
        ...state,
        season: action.season,
      };

    case 'REMOVE_FILTER':
      const stateWithoutFilter = produce(state, draftState => {
        draftState.beaches_filters[action.filterName] = false;
      });
      return stateWithoutFilter;
    case 'GET_BEACHES_LIST_SUCCESS':
      return {
        ...state,
        all_beaches_closed: action.allBeachesClosed,
        risks : action.risks,
        beaches_list: action.beaches_list,
      };
    case 'INIT_FAVORITES':
      return {
        ...state,
        beaches_favorites: action.favorites,
      };
    case 'INIT_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.notifications,
      };

    case 'SEND_FILTERS':
      return {
        ...state,
        beaches_filters: action.beaches_filters,
      };

    case 'LAUNCH_TUTORIEL':
      return {
        ...state,
        tutoriel: true,
      };

    case 'TOGGLE_FAVORITES':
      const nextState = produce(state, draftState => {
        if (!draftState.beaches_favorites.includes(action.id_beach)) {
          draftState.beaches_favorites.push(action.id_beach);

          (async function() {
            var tmp = JSON.stringify(draftState.beaches_favorites);
            await localStorage.setItem('@plouf:favorites', tmp);
          })();
        } else {
          var index = draftState.beaches_favorites.indexOf(action.id_beach);
          if (index > -1) {
            draftState.beaches_favorites.splice(index, 1);
            (async function() {
              var tmp = JSON.stringify(draftState.beaches_favorites);
              await localStorage.setItem('@plouf:favorites', tmp);
            })();
          }
        }
      });
      return nextState;

    default:
      return state;
  }
};
